import React, { useEffect, useState } from "react";
import { useFetchApi } from "../../hooks/useFetchApi";
import H5 from "../../components/Typography/H5";
import { FeaturedCard } from "../../components/Card";

interface CompanyProfilesProps {
  // Define your props here
  selectedStocks: any;
}

const CompanyProfiles: React.FC<CompanyProfilesProps> = (props) => {
  const { selectedStocks } = props;
  const [profiles, setProfiles] = useState<Array<any>>([]);
  // Add your component logic here
  const { execute, response, loading } = useFetchApi("/api/company/profiles", {
    stock_ids: selectedStocks,
  });

  useEffect(() => {
    execute();
  }, [selectedStocks]);

  useEffect(() => {
    if (!loading && response) {
      setProfiles(response);
    }
  }, [loading, response]);

  return (
    <div className="flex w-full flex-col">
      {profiles.length ? (
        <>
          {profiles.map((profile: any, i: number) => (
            <FeaturedCard
              imageUrl={`/api/static/${profile.company_logo}`}
              title={profile.company_name}
              description={profile.profile}
              ticker_symbol={profile.ticker_symbol}
            />
          ))}
        </>
      ) : (
        <H5>No company profiles found</H5>
      )}
    </div>
  );
};

export default CompanyProfiles;
